import { Ng2StateDeclaration } from "@uirouter/angular";
import { DataStoryModule } from "./data-story.module";

const loadChildren: () => Promise<typeof DataStoryModule> = () => import(/* webpackChunkName: "data-story" */ "./data-story.module").then((m) => m.DataStoryModule);

const insightboardsFutureState: Ng2StateDeclaration = {
  name: "gtmhub.insightboards.**",
  url: "/insightboards",
  loadChildren,
};

const insightboardFutureState: Ng2StateDeclaration = {
  name: "gtmhub.insightboard.**",
  url: "/insightboard",
  loadChildren,
};

const virtualDataSourceFutureState: Ng2StateDeclaration = {
  name: "gtmhub.virtualDatasource.**",
  url: "/virtual-data-source",
  loadChildren,
};

const dataSourcesFutureState: Ng2StateDeclaration = {
  name: "gtmhub.dataflow.**",
  url: "/data-sources",
  loadChildren,
};

const installerFutureState: Ng2StateDeclaration = {
  name: "gtmhub.welcome.**",
  url: "/welcome",
  loadChildren,
};

const insightFutureState: Ng2StateDeclaration = {
  name: "gtmhub.insight.**",
  url: "/insight",
  loadChildren,
};

export default [insightboardsFutureState, insightboardFutureState, virtualDataSourceFutureState, dataSourcesFutureState, installerFutureState, insightFutureState];
